import { useEffect, useRef, useState } from 'react';

export const useTableLayout = (flattenedValues: string[], columnCount: number) => {
  const longestRef = useRef<HTMLSpanElement | null>(null);

  const [columnMinWidth, setColumnMinWidth] = useState<number>(84);
  const [isSmallerThanDeviceWidth, setIsSmallerThanDeviceWidth] = useState(false);

  const longestText = flattenedValues.reduce((a, b) => (a.length > b.length ? a : b), '');
  const fixedColumnWidth = 88;

  useEffect(() => {
    if (!longestRef.current) return;

    const el = longestRef.current;
    const isClamped = el.scrollHeight > el.clientHeight;

    if (isClamped) {
      const newWidth = Math.ceil(columnMinWidth + 20); // padding + 여유
      setColumnMinWidth(Math.max(84, newWidth));
    }

    const dataColumnCount = Math.max(0, columnCount - 1);
    const totalWidth = fixedColumnWidth + dataColumnCount * columnMinWidth;

    setIsSmallerThanDeviceWidth(window.innerWidth > totalWidth);
  }, [columnMinWidth, columnCount, fixedColumnWidth]);

  const handleSetColRef = (cell: string, ref: HTMLSpanElement | null) => {
    const isLongest = cell === longestText;
    if (isLongest && ref) {
      longestRef.current = ref;
    }
  };

  return {
    longestRef,
    sizeTable: {
      fixedColumnWidth: `${fixedColumnWidth}px`,
      columnMinWidth: `${columnMinWidth}px`,
      handleSetColRef,
    },
  };
};
